import { useContext } from 'react'
import { conceptsCarsContext } from '../../pages/vehicle/concepts'
import { CarSearchForm } from './CarSearchForm'

export const ConceptsCarSearch = () => {
  const { updateFilter, filter } = useContext(conceptsCarsContext)

  return (
    <CarSearchForm
      filter={filter}
      onSubmit={updateFilter}
      listType='opened'
    />
  )
}